// frontend/src/components/event/EventFormatBadge.js
import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import LiveBadge from "./LiveBadge";
import LocationBadge from "./LocationBadge";
import HybridBadge from "./HybridBadge";

const EventFormatBadge = ({ format, location, eventType, size = "md" }) => {
  const { t } = useLanguage();

  if (format === "online") {
    return <LiveBadge type={eventType} size={size} />;
  }

  if (format === "in_person") {
    if (location) {
      return <LocationBadge location={location} size={size} />;
    }
    // Fallback for in-person events without location data
    const sizeClasses = {
      sm: "text-xs px-2 py-1",
      md: "text-sm px-3 py-1",
      lg: "text-base px-3 py-1.5",
    };
    return (
      <span
        className={`inline-flex items-center gap-1 rounded font-bold bg-[#002855] text-white ${sizeClasses[size]}`}
      >
        {t({ de: "Vor Ort", en: "In-Person" })}
      </span>
    );
  }

  if (format === "hybrid") {
    return (
      <HybridBadge
        eventType={eventType}
        location={location}
        size={size}
      />
    );
  }

  // Default fallback
  return <LiveBadge type={eventType} size={size} />;
};

export default EventFormatBadge;
